const AMOUNT_FORMATTER = new Intl.NumberFormat("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

/** Accounting style: negatives in brackets, zero as a dash, null (no baseline) as an em dash. */
export function formatStatementAmount(value: string | null): string {
    if (value === null) return "—";
    const amount = Number(value);
    if (amount === 0) return "-";
    const formatted = AMOUNT_FORMATTER.format(Math.abs(amount));
    return amount < 0 ? `(${formatted})` : formatted;
}
